const ANALYTICS_EVENTS = {
    OTP_Sent: "OTP_Sent",
    OTP_Verified_Success: "OTP_Verified_Success",
    OTP_Verification_Failed: "OTP_Verification_Failed",
    Login_Success: "Login_Success",
    User_Profile_Completed: "User_Profile_Completed",
    Search_Performed: "Search_Performed",
    Session_Start: "Session_Start",
    Session_End: "Session_End",
    Page_Viewed: "Page_Viewed",
    Content_Shared: "Content_Shared",
    Page_Performance: "Page_Performance",
    WEB_VITALS_RECORDED: "WEB_VITALS_RECORDED",
    Scroll_Engaged: "Scroll_Engaged",
    Add_to_Cart: "Add_to_Cart",
    Cart_Item_Updated:"Cart_Item_Updated",
    Remove_from_Cart: "Remove_from_Cart",
    Cart_Viewed: "Cart_Viewed",
    Cart_Abandoned: "Cart_Abandoned",
    Payment_Initiated: "Payment_Initiated",
    Payment_Failed:"Payment_Failed",
    Charged: "Charged",
    Order_Confirmed: "Order_Confirmed",
    Repeat_Purchase: "Repeat_Purchase",
    AI_Chat_Opened: "AI_Chat_Opened",
    AI_Question_Asked: "AI_Question_Asked",
    AI_Response_Received: "AI_Response_Received",
    AI_Returning_User: "AI_Returning_User",
    AI_Personal_Info_Captured: "AI_Personal_Info_Captured",
    Live_Darshan_Started: "Live_Darshan_Started",
    Live_Darshan_Ended: "Live_Darshan_Ended",
    Checkout_Initiated: "Checkout_Initiated",
}

export {
    ANALYTICS_EVENTS,
}